import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { checkAccess } from '../../actions/WelcomeActions';
import axios from 'axios';
import { Row, Col} from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { getUid } from '../../utils/helper';
import { config } from '../../constants/domainConfig';
import { showMessage } from '../../actions/FlashMessageActions';
import Loader from './../loader/loader';

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            msisdn: config.countryCode,
            errorInApi: {},
            pwdResetSuccessfully: false,
            msisdnEmpty: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.isValid = this.isValid.bind(this);
    }

    componentWillMount(){
    }
    handleChange(e) {
        const { value, maxLength, name } = e.target;
        const truncatedValue = value.slice(0, maxLength);
        this.setState({ [name]: truncatedValue });
    }
    handleKeyUp(e){
        this.setState({
            errorInApi: {},
            msisdnEmpty: false
        })
        if (e.keyCode == 13) {
            this.handleSubmit(e);
        }
        else return;
    }
    isValid(){
        if (this.state.msisdn == '') {
            this.setState({
                msisdnEmpty: true
            });
            return false;
        }
        return true;
    }
    handleSubmit(e) {
        e.preventDefault();

        if (this.isValid()) {
            this.props.show();
            this.transformRequest(axios.defaults.headers);
            axios.get(`https://de-mcb-api.sam-media.com/api/v2/retrieve-password/pt/go4mobility?msisdn=${this.state.msisdn}&domain=${(window.location.hostname == 'localhost') ? 'pt.gamezones.biz' : window.location.hostname}`)
                .then(response => {
                    this.props.hide();
                    if (response.data.state == 'success') {
                        this.setState({
                            pwdResetSuccessfully: true
                        })
                    }
                    else {
                        this.setState({
                            errorInApi:{
                                subNotFound: true
                            }
                            
                        })

                    }
                })
                .catch(err => {
                    this.props.hide();
                    console.log('err-----------------------', err);
                    this.setState({
                        errorInApi:{
                            pwdResetCallFailed: true
                        }
                    })
                })
        }
    }
    transformRequest(headers) {
        delete headers.common.authorization;
        return;
    }

    render() {
        
            return (
                <div className="login animated fadeIn">
                    <Row className="justify-content-center">
                        <Col>
                            <Row className="login-page-header">
                                <div className="login-page-header-child">
                                    <img className="login-page-logo" src="./img/logo.png" alt="Mobio360" width="125px" />
                                </div>
                            </Row>
                            <Row className="login-page-content">
                                <h1>
                                    <FormattedMessage id="forgotYourPwd?"
                                        defaultMessage="Forgot your Password?"
                                    />
                                </h1>
                                <p>
                                    <FormattedMessage id="enterYourMobile"
                                        defaultMessage="Enter your mobile number. An SMS with your password will be sent to you."
                                    />
                                </p>

                                <div className="login-page-mobile_num">
                                        <input autoFocus type="number" name="msisdn" maxLength="15" value={this.state.msisdn} onChange={this.handleChange} onKeyUp={this.handleKeyUp} className="LoginRoute-number" />
                                        {this.state.msisdnEmpty && <span className="error-message">
                                            <FormattedMessage id="phoneNumberRequired"
                                                defaultMessage="Phone number is required."
                                            />
                                        </span>}
                                    
                                        <button type="submit" onClick={this.handleSubmit} className="LoginRoute-button">
                                            <FormattedMessage id="submit"
                                                defaultMessage="Submit"
                                            />
                                            <i className="icon-back"></i>
                                        </button>
                                        {this.state.pwdResetSuccessfully && <span className="success-message">
                                            <FormattedMessage id="pwdResetSuccessfully"
                                                defaultMessage="An SMS with your password has been sent to you. Please try to login again using that password."
                                            />
                                        </span>
                                        }
                                    {this.state.errorInApi.pwdResetCallFailed && <span className="error-message">
                                            <FormattedMessage id="pwdResetFailed"
                                                defaultMessage="Password could not be reset. Please try again."
                                            />
                                        </span>
                                        }
                                        {this.state.errorInApi.subNotFound && <span className="error-message">
                                            <FormattedMessage id="subNotFound"
                                                defaultMessage="Your subscription with this mobile number was not found. Please subscribe to the service to continue."
                                            />
                                        </span>
                                        }
                                </div>
                            </Row>
                        </Col>
                                <Row className="login-page-content ">
                                <FormattedMessage id="alreadySubscribed"
                                    defaultMessage="Already Subscribed?"
                                />
                                    <Link className="reg-link" to={`/loginWithUsername/`}>
                                        <FormattedMessage id="login"
                                            defaultMessage="Login"
                                        />
                                    </Link>
                                </Row>
                    </Row>
                </div>
            );
        
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        loader: state.ActivityIndicatorReducer,
        access: state.WelcomeReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        checkAccess,
        show,
        hide,
        showMessage,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/Login/ForgotPassword.js